import axios from 'axios'
import * as vars from './vars';
import {getTimezone} from 'Utils/time'

export function updateProfilePhoto(buffer, type, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/users/UploadProfilePhotoFromWeb`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            buffer: buffer,
            contentType: type
        }
    })
}

export function removeProfilePhoto(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/users/RemoveProfilePhoto`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function updateProfileResume(buffer, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/users/UploadResumeFromWeb`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            buffer: buffer,
        }
    })
}

export function updateUserPhone(data, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/users/UpdatePhoneNumber',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

export function updateUser(data, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/users/UpdateUser',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

export function getUserProfile(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/users/FetchUserProfile',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function emailAvailable(getEmailAvailabilityRequest) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/authentication/GetEmailAvailability',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: getEmailAvailabilityRequest
    })
}

export function getSignedInUserInformation(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/users/GetSignedInUserInformation',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function deleteUser(password, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/users/RemoveUserAccount',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            password: password
        }
    })
}

export function updateUsername(userName, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/users/UpdateUsername',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            userName: userName
        }
    })
}

export function deleteResume(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/users/RemoveUserResume',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function updateEmailStart(email, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/users/InitiateEmailUpdate',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            email: email
        }
    })
}

export function updateEmailFinish(email, code, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/users/CompleteEmailUpdate',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            email: email,
            code: code
        }
    })
}

export function getWeeklySnapshot(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/scheduling/GetWeeklySnapshot',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            timezone: getTimezone()
        }
    })
}

export function getAvailabilityLocal(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/scheduling/GetUserLocalAvailability',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            timezone: getTimezone()
        }
    })
}

export function setAvailability(availability, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/scheduling/SetUserAvailability',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            timezone: getTimezone(),
            availability: availability
        }
    })
}

export function searchMentors(query, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/discovery/DiscoverMentors',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {query: query}
    })
}


export function addAttribute(addUserAttributeRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/users/AddUserAttribute',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: addUserAttributeRequest
    })
}

// attribute = [“skills” | “clubs” | “accomplishments” | “job_positions” | “experiences”]
export function removeAttribute(attribute, attributeId, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/users/RemoveUserAttribute',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            attribute: attribute,
            attributeId: attributeId
        }
    })
}

// attribute = [“skills” | “clubs” | “accomplishments” | “job_positions” | “experiences”]
export function getAttribute(attribute, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/users/GetUserAttribute',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {
            attribute: attribute
        }
    })
}